(function () {
    'use strict';

    var id = 'secureHttpInterceptor';

    angular.module('app')
        .factory(id, ['$injector', '$q', '$window', '$rootScope', secureHttpInterceptor]);

    function secureHttpInterceptor($injector, $q, $window, $rootScope) {
        var interceptor = {
            request: request,
            responseError: responseError,
            firstRequest: true
        };

        return interceptor;

        function request(config) {
            var queryString = new URL(window.location.toString()).searchParams;

            if (interceptor.firstRequest) {
                interceptor.firstRequest = false;


                if (queryString.get("device")) {
                    $rootScope.refMobile = queryString.get("device") === "mobile";
                    window.refMobile = queryString.get("device") === "mobile";
                }
                if (queryString.get('at') &&
                    queryString.get('at_exp') &&
                    queryString.get('rt') &&
                    queryString.get('rt_exp')) {

                    window.localStorage.setItem("accessToken", decodeURIComponent(queryString.get('at').replace(/ /g, '+')));
                    window.localStorage.setItem("accessTokenExpires", decodeURIComponent(queryString.get('at_exp').replace(/ /g, '+')));
                    window.localStorage.setItem("refreshToken", decodeURIComponent(queryString.get('rt').replace(/ /g, '+')));
                    window.localStorage.setItem("refreshTokenExpires", decodeURIComponent(queryString.get('rt_exp').replace(/ /g, '+')));
                    var userSvc = $injector.get('userSvc');
                    userSvc.getUserInfo(null, true).then(function () {
                        //console.log()
                    }).finally(function () {
                        window.refMobile = true;
                        $rootScope.refMobile = true;

                        if (config.params && config.params.captchaTokenCustom) {
                            config.headers['Captcha-Token'] = config.params.captchaTokenCustom;
                            delete config.params.captchaTokenCustom;
                        }
                        else if (config.data && config.data.captchaTokenCustom) {
                            config.headers['Captcha-Token'] = config.data.captchaTokenCustom;
                            delete config.data.captchaTokenCustom;
                        }

                        if (config.params && config.params.ETToken) {
                            config.headers['ET-Token'] = config.params.ETToken;
                            delete config.params.ETToken;
                        }
                        else if (config.data && config.data.ETToken) {
                            config.headers['ET-Token'] = config.data.ETToken;
                            delete config.data.ETToken;
                        }

                        // EImage-Captcha headers for /auth/sevc and /verification/sevc endpoints
                        if (config.params && config.params.EImageCaptchaKey) {
                            config.headers['EImage-Captcha-Key'] = config.params.EImageCaptchaKey;
                            config.headers['EImage-Captcha-Value'] = config.params.EImageCaptchaValue;
                            delete config.params.EImageCaptchaKey;
                            delete config.params.EImageCaptchaValue;
                        }
                        else if (config.data && config.data.EImageCaptchaKey) {
                            config.headers['EImage-Captcha-Key'] = config.data.EImageCaptchaKey;
                            config.headers['EImage-Captcha-Value'] = config.data.EImageCaptchaValue;
                            delete config.data.EImageCaptchaKey;
                            delete config.data.EImageCaptchaValue;
                        }

                        config.headers["Content-Language"] = window.lang;
                        const token = $window.localStorage.getItem("accessToken");
                        const expire = $window.localStorage.getItem("accessTokenExpires");
                        if (!config.skipAuthorization && config.url.indexOf('.html') === -1 && config.url.indexOf('.json') === -1 && token && new Date(expire).getTime() > new Date().getTime()) {
                            config.headers.Authorization = "Bearer " + token;
                        }
                        return config;
                    });
                }
            }
            if (config.url.indexOf('.html') === -1 && config.url.indexOf('.json') === -1) {
                if (config.params && config.params.captchaTokenCustom) {
                    config.headers['Captcha-Token'] = config.params.captchaTokenCustom;
                    delete config.params.captchaTokenCustom;
                }
                else if (config.data && config.data.captchaTokenCustom) {
                    config.headers['Captcha-Token'] = config.data.captchaTokenCustom;
                    delete config.data.captchaTokenCustom;
                }

                // Turnstile token for sendcode and update_phone endpoints
                if (config.params && config.params.ETToken) {
                    config.headers['ET-Token'] = config.params.ETToken;
                    delete config.params.ETToken;
                }
                else if (config.data && config.data.ETToken) {
                    config.headers['ET-Token'] = config.data.ETToken;
                    delete config.data.ETToken;
                }

                // EImage-Captcha headers for /auth/sevc and /verification/sevc endpoints
                if (config.params && config.params.EImageCaptchaKey) {
                    config.headers['EImage-Captcha-Key'] = config.params.EImageCaptchaKey;
                    config.headers['EImage-Captcha-Value'] = config.params.EImageCaptchaValue;
                    delete config.params.EImageCaptchaKey;
                    delete config.params.EImageCaptchaValue;
                }
                else if (config.data && config.data.EImageCaptchaKey) {
                    config.headers['EImage-Captcha-Key'] = config.data.EImageCaptchaKey;
                    config.headers['EImage-Captcha-Value'] = config.data.EImageCaptchaValue;
                    delete config.data.EImageCaptchaKey;
                    delete config.data.EImageCaptchaValue;
                }

                /* if (config.data && config.data.source) {
                    config.headers['UserChannel'] = config.data.source;
                    delete config.data.source;
                } */

                // Check if user registration request from HangiKredi campaign
                if ($rootScope.isHangiKrediCampaign) {
                    config.headers['UserChannel'] = '11';
                }

                if ($rootScope.isBank) {
                    config.headers['UserChannel'] = $rootScope.clientData.source;
                }
            }

            config.headers["Content-Language"] = window.lang;
            const token = $window.localStorage.getItem("accessToken");
            const expire = $window.localStorage.getItem("accessTokenExpires");
            if (!config.skipAuthorization && config.url.indexOf('.html') === -1 && config.url.indexOf('.json') === -1 && token && new Date(expire).getTime() > new Date().getTime()) {
                config.headers.Authorization = "Bearer " + token;
            }
            return config;
        }

        //ÖNEMLİ: RefreshToken'ı loading mantığı ile engellemek lifecycle sorunlarına neden oluyor. Yapmayalım.
        function responseError(response) {
            var deferred = $q.defer();
            if (!response.config)
                deferred.reject(response);
            else {
                const url = response.config.url.toLowerCase();
                if (response.status === 401 && url.indexOf("externallogin") === -1) {
                    var userSvc = $injector.get('userSvc');
                    const refreshToken = $window.localStorage.getItem("refreshToken");
                    const refreshTokenExpires = $window.localStorage.getItem("refreshTokenExpires");
                    if (refreshToken && new Date(refreshTokenExpires).getTime() > new Date().getTime()) {
                        userSvc.refresh().then(
                            function (res) {
                                if (res && res.accessToken) {
                                    $window.localStorage.setItem('accessToken', res.accessToken);
                                    $window.localStorage.setItem('accessTokenExpires', res.accessTokenExpiration);
                                    $window.localStorage.setItem('refreshToken', res.refreshToken);
                                    $window.localStorage.setItem('refreshTokenExpires', res.refreshTokenExpiration);

                                    response.config.headers.Authorization = "Bearer " + res.accessToken;

                                    var $http = $injector.get('$http');
                                    $http(response.config).then(function (result) {
                                        deferred.resolve(result);
                                    }, function () {
                                        deferred.reject(response);
                                    });
                                } else {
                                    userSvc.setUser();
                                    deferred.reject(response);
                                }
                            },
                            function () {
                                userSvc.setUser();
                                deferred.reject(response);
                            });
                    } else {
                        userSvc.setUser();
                        deferred.reject(response);
                    }
                } else {
                    deferred.reject(response);
                }
            }
            return deferred.promise;
        }
    }
})();
